import { FC, useState } from 'react';
import Checkbox from '__components/Inputs/CheckboxGroup/Checkbox';

export const ApplyAllCheckbox: FC<{
  label: string;
  onCheck: () => void;
}> = ({ label, onCheck }) => {
  const [checked, setChecked] = useState(false);

  const onChange = () => {
    setChecked(true);
    onCheck();
    setTimeout(() => setChecked(false), 300);
  };

  return <Checkbox label={label} onChange={onChange} checked={checked} />;
};
